var map = {
	"./bishop-bw-dark.png": 7830,
	"./bishop-bw-light.png": 1384,
	"./bishop-default-dark.png": 2670,
	"./bishop-default-light.png": 3680,
	"./king-bw-dark.png": 4396,
	"./king-bw-light.png": 9702,
	"./king-default-dark.png": 2068,
	"./king-default-light.png": 1182,
	"./knight-bw-dark.png": 3530,
	"./knight-bw-light.png": 5316,
	"./knight-default-dark.png": 5170,
	"./knight-default-light.png": 5708,
	"./pawn-bw-dark.png": 7135,
	"./pawn-bw-light.png": 6287,
	"./pawn-default-dark.png": 9101,
	"./pawn-default-light.png": 3877,
	"./queen-bw-dark.png": 7917,
	"./queen-bw-light.png": 8021,
	"./queen-default-dark.png": 9627,
	"./queen-default-light.png": 2163,
	"./rook-bw-dark.png": 4894,
	"./rook-bw-light.png": 3040,
	"./rook-default-dark.png": 9126,
	"./rook-default-light.png": 5896
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7958;